import { EducationalMaterialCategory } from '@dreryk/egabinet-knowledge-base-frontend-api';

import { Message } from '@dreryk/react-components';

import { getCategoryLabel, useOptions } from './EducationalMaterialStatus.utils';

type EducationalMaterialMessageProps = {
   readonly category?: EducationalMaterialCategory;
};

export const EducationalMaterialMessage = (props: EducationalMaterialMessageProps): JSX.Element | null => {
   const options = useOptions();

   if (!props.category) {
      return null;
   }

   const categoryLabel = getCategoryLabel(props.category);
   if (!categoryLabel) {
      return null;
   }

   return (
      <Message
         displayIndicator
         type={props.category}
         options={options}
         label={categoryLabel}
         testId={'knowledgeCardStatus'}
      />
   );
};
